import axiosInstance from '../AxiosInstance';

export function getSignInActivity({ page = 1 } = {}) {
    return axiosInstance.get('sign-in-activity', { params: { page } });
}

export function markSignInEventNotMe(eventUuid) {
    return axiosInstance.post(`sign-in-activity/${eventUuid}/not-me`);
}

export function revokeOtherSessions({ currentPassword, triggeringEventUuid = null }) {
    return axiosInstance.post('sign-in-activity/revoke-other-sessions', {
        current_password: currentPassword,
        ...(triggeringEventUuid ? { triggering_event_uuid: triggeringEventUuid } : {}),
    });
}
